import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollAnimate } from '../components/ScrollAnimate';
import { SEO } from '../components/SEO';
import { CheckIcon, IconKoklonya } from '../components/icons/SiteIcons';

const koklonyaFeatures = [
  'Flock & Production Tracking',
  'Feed Mill & Formulation',
  'Procurement & Inventory',
  'HR & Ghana Payroll',
  'IFRS-Ready Accounting',
  'Multi-Farm Roles & Access',
];

const features = [
  'Security Health Score',
  'Email Threat Monitoring',
  'Dark Web Monitoring',
  'WhatsApp Alerts',
  'AI Weekly Brief',
  'Compliance Reports',
  'Light & Dark Theme',
  'Global Pricing',
];

export function ProductsPage() {
  return (
    <>
      <SEO
        title="Products — logNsec"
        description="ShieldSME and the full logNsec security product portfolio. Enterprise-grade protection built for growing businesses."
        canonical="/products"
      />
      <section className="bg-[#F5F5F5] px-5 py-20 text-center md:px-8 md:py-24">
        <div className="mx-auto max-w-3xl">
          <ScrollAnimate>
            <p className="text-label-site text-[#65676B]">Our Products</p>
            <h1 className="text-section mt-3">
              A Growing Portfolio of
              <br />
              Security Solutions
            </h1>
            <p className="mx-auto mt-6 max-w-[560px] text-body-site">
              Each logNsec product solves a specific security challenge — starting with
              the businesses that need protection most.
            </p>
          </ScrollAnimate>
        </div>
      </section>

      <section className="bg-white px-5 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-7xl">
          <ScrollAnimate>
            <article className="card-site p-8 md:p-12">
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-[3fr_2fr] lg:gap-12">
                <div>
                  <span className="inline-flex rounded-[20px] bg-[#E7F0FF] px-3 py-1 text-xs font-semibold text-[#0064E0]">
                    Flagship Product
                  </span>
                  <h2 className="mt-6 text-[32px] font-bold text-[#1C1E21]">ShieldSME</h2>
                  <p className="mt-5 text-body-site">
                    AI-powered cybersecurity monitoring for small and medium businesses
                    worldwide. Email threats, dark web monitoring, WhatsApp alerts, and
                    compliance reports — all in one platform.
                  </p>
                  <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-[17px] text-[#1C1E21]">
                        <CheckIcon />
                        {f}
                      </li>
                    ))}
                  </ul>
                  <p className="mt-8 text-2xl font-bold text-[#0064E0]">From $25/month</p>
                  <a
                    href="https://shieldsme.lognsec.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex rounded-lg bg-[#0064E0] px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-[#0056C8]"
                  >
                    Visit ShieldSME →
                  </a>
                </div>
                <div className="flex h-full min-h-0 flex-col justify-center">
                  <div className="grid h-full w-full grid-cols-2 grid-rows-2 gap-4 [grid-template-rows:1fr_1fr] [grid-template-columns:1fr_1fr] items-stretch">
                    {[
                      { label: 'SECURITY SCORE', value: '72/100' },
                      { label: 'MONITORING', value: '24/7' },
                      { label: 'CURRENCIES', value: '11' },
                      { label: 'FRAMEWORKS', value: '13' },
                    ].map((m) => (
                      <div
                        key={m.label}
                        className="flex h-full min-h-[120px] flex-col items-center justify-center rounded-[12px] border border-[#E4E6EB] border-l-[3px] border-l-transparent bg-[#F8F9FA] p-6 text-center transition-[border-left-color] duration-200 ease hover:border-l-[#0064E0]"
                      >
                        <p className="mb-2 text-[12px] font-medium uppercase leading-normal tracking-[0.06em] text-[#65676B]">
                          {m.label}
                        </p>
                        <p className="mb-0 text-[36px] font-extrabold leading-none text-[#0064E0]">
                          {m.value}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          </ScrollAnimate>

          <ScrollAnimate className="mt-8">
            <article className="card-site p-8 md:p-12">
              <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[3fr_2fr] lg:gap-12">
                <div>
                  <span className="inline-flex rounded-[20px] bg-[#E7F0FF] px-3 py-1 text-xs font-semibold text-[#0064E0]">
                    Also Live
                  </span>
                  <h2 className="mt-6 text-[32px] font-bold text-[#1C1E21]">Koklonya</h2>
                  <p className="mt-5 text-body-site">
                    Farm management &amp; accounting ERP for poultry businesses — flocks,
                    feed mill, procurement, HR &amp; payroll, and IFRS-ready books in a
                    single multi-tenant platform.
                  </p>
                  <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {koklonyaFeatures.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-[17px] text-[#1C1E21]">
                        <CheckIcon />
                        {f}
                      </li>
                    ))}
                  </ul>
                  <a
                    href="https://www.koklonya.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-8 inline-flex rounded-lg bg-[#0064E0] px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-[#0056C8]"
                  >
                    Visit Koklonya →
                  </a>
                </div>
                <div className="flex items-center justify-center">
                  <IconKoklonya size={160} />
                </div>
              </div>
            </article>
          </ScrollAnimate>

          <ScrollAnimate className="mt-16">
            <h2 className="text-section text-center">Coming Soon</h2>
          </ScrollAnimate>
          <ScrollAnimate className="mt-10">
            <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-3">
              {[
                {
                  title: 'logNsec MSSP Portal',
                  time: 'Q3 2025',
                  desc: 'Central command portal for managed security service delivery across multiple client environments.',
                },
                {
                  title: 'logNsec Compliance Engine',
                  time: 'Q4 2025',
                  desc: 'Automated compliance evidence collection for GDPR, NDPR, POPIA, and 10+ frameworks with Wiki.js integration.',
                },
                {
                  title: 'logNsec Forensics Platform',
                  time: '2026',
                  desc: 'AI-assisted digital forensics and incident investigation platform for enterprise security teams.',
                },
              ].map((c) => (
                <article key={c.title} className="card-site flex h-full flex-col">
                  <span className="text-sm font-semibold text-[#0064E0]">{c.time}</span>
                  <h3 className="text-card-title mt-4">{c.title}</h3>
                  <p className="mt-3 text-body-site flex-1">{c.desc}</p>
                  <Link
                    to="/contact"
                    className="mt-8 block w-full rounded-lg border-2 border-[#0064E0] py-3 text-center text-base font-semibold text-[#0064E0] transition-colors hover:bg-[#E7F0FF]"
                  >
                    Join Waitlist
                  </Link>
                </article>
              ))}
            </div>
          </ScrollAnimate>
        </div>
      </section>
    </>
  );
}
